import { getAccessToken } from './accessToken';
import { me } from './me';
import { refreshToken } from './refreshToken';

const authService = {
  me,
  refreshToken,
  getAccessToken,
};

const getIpAddress = () => fetch(`https://api.ipify.org`);

export { authService, getIpAddress };
